import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Spinner, Text, makeStyles } from "@fluentui/react-components";
import apiServices from "../service";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    gap: "16px",
  },
});

const CashCalcCallback: React.FC = () => {
  const styles = useStyles();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const [message, setMessage] = useState("Completing CashCalc connection…");

  useEffect(() => {
    const code = searchParams.get("code");
    const state = searchParams.get("state");
    const error = searchParams.get("error");

    if (error) {
      setStatus("error");
      setMessage(`CashCalc authorisation denied: ${error}`);
      return;
    }

    if (!code) {
      setStatus("error");
      setMessage("No authorisation code received from CashCalc.");
      return;
    }

    // state = `${consultantUserId}:${tenantId}:${timestamp}`
    const consultantUserId = state ? state.split(":")[0] : undefined;

    apiServices.cashCalc
      .exchangeToken({ code, consultantUserId })
      .then(() => {
        setStatus("success");
        setMessage("Connected to CashCalc! You can close this window.");
        setTimeout(() => window.close(), 2000);
      })
      .catch((err: any) => {
        setStatus("error");
        const detail =
          err?.response?.data?.error?.message?.[0] ||
          err?.response?.data?.message ||
          err?.message ||
          "Unknown error";
        setMessage(`Failed to complete CashCalc connection: ${detail}`);
      });
  }, [searchParams]);

  return (
    <div className={styles.container}>
      {status === "loading" && <Spinner size="large" label={message} />}
      {status === "success" && (
        <Text size={500} weight="semibold" style={{ color: "#34a853" }}>
          ✓ {message}
        </Text>
      )}
      {status === "error" && (
        <Text size={400} style={{ color: "#d13438" }}>
          {message}
        </Text>
      )}
    </div>
  );
};

export default CashCalcCallback;
